module.exports = __webpack_public_path__ + "static/img/kols15.7144a60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols15.png
// module id = uBir
// module chunks = 0